<table class="table table-striped" *ngIf="subTopic">
  <tbody>
    <tr><td>Date Created</td><td>{{subTopic.datecreated}}</td></tr>
    <tr><td>Last Updated</td><td>{{subTopic.lastupdated}}</td></tr>
    <tr><td>Name</td><td>{{subTopic.name}}</td></tr>
    <tr><td>Description</td><td>{{subTopic.description}}</td></tr>
    <tr><td>Code</td><td>{{subTopic.subtopiccode}}</td></tr>
    <tr><td>Is Open</td><td>{{subTopic.is_open}}</td></tr>
    </tbody>
    </table>
    <div *ngIf="currentFactBookList.length>0">
    <h6 class="alert alert-info text-center"> New Facts To Add</h6>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Body</th>
          <th>id</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fact of currentFactBookList;" style="list-style: none;">
          <td>{{fact.text}}</td>
          <td>{{fact.id}}</td>
          <td><button (click)="removeItemFromArray(fact.id,currentFactBookList)" class="mt-1"> Remove</button></td>
        </tr>
        </tbody>
        </table>

      </div>
    <div class="text-center" *ngIf="startFactCount!=currentFactBookList.length ">
      <button (click)="onConfirm()" class="mt-1"> Confirm Changes</button>
      <app-spinner *ngIf="isSaving"></app-spinner>
    </div>
<form  [formGroup]="searchFactForm" class="mt-5" *ngIf="searchFactForm" >
  <div class="row">
            <div class="col-sm-3" > Search Facts</div>
            <div class="col-sm-4" >
                <input   formControlName="searchInput" class="form-control"/>
            </div>
     </div>
</form>


<ul>
    <tr *ngFor="let fact of factBookList;" style="list-style: none;">
      <td>{{fact.text}}</td>
      <td><button (click)="addFact(fact.id)" class="mt-1"> Add Fact</button></td>
    </tr>
</ul>

<hr/>
